// Detail-page slugs available for click-through
const HAS_DETAIL = {
  "Microneedling Rejuran": "microneedling-rejuran",
  "Microneedling SkinPen": "skinpen",
  "Morpheus8": "morpheus8",
  "IPL Lumecca": "ipl-lumecca",
  "IPL Lumecca Legs": "lumecca-legs",
  "Hydrafacial Deluxe": "hydrafacial-deluxe"
};

export const catalog = [
  {
    title: "Collagen Stimulators",
    subtitle: "Bio-remodelling injectables that awaken natural collagen.",
    items: [
      { name: "Linerase Collagen", duration: "1 hour", price: "$350" },
      { name: "Juvelook Collagen", duration: "1 hour", price: "$550" }
    ]
  },
  {
    title: "Skin Biorevitalization",
    subtitle: "Micro-hydration protocols that restore skin quality from within.",
    items: [
      { name: "Plinest", duration: "1 hour", price: "$380" },
      { name: "Fillmed HA 135", duration: "1 hour", price: "$240" },
      { name: "Jalupro Super Hydro", duration: "1 hour", price: "$380" },
      { name: "Jalupro HMW", duration: "1 hour", price: "$350" }
    ]
  },
  {
    title: "Advanced Treatments",
    subtitle: "Device-based protocols for structural rejuvenation.",
    items: [
      { name: "Microneedling Rejuran", duration: "1 hour 30 minutes", price: "$480" },
      { name: "Microneedling SkinPen", duration: "1 hour 30 minutes", price: "$350" },
      { name: "Microneedling Plinest", duration: "", price: "$450" },
      { name: "Microneedling Linrase Collagen", duration: "", price: "$480" },
      { name: "Morpheus8", duration: "1 hour 30 minutes", price: "$850" },
      { name: "Morpheus8 Package — 3 Sessions", duration: "", price: "$750 per session" },
      { name: "Morpheus Resurfacing for Acne and Small Wrinkles — Face and Neck", duration: "", price: "$750" },
      { name: "IPL Lumecca", duration: "45 minutes", price: "$350" },
      { name: "IPL Lumecca Package — 3 Sessions", duration: "", price: "$900 total" }
    ]
  },
  {
    title: "PRX-T33 Therapy",
    subtitle: "No-downtime bio-revitalising resurfacing.",
    items: [
      { name: "PRX-T33 Face", duration: "", price: "$200" },
      { name: "PRX-T33 Neck", duration: "", price: "$250" },
      { name: "PRX-T33 Face + Neck", duration: "", price: "$250" },
      { name: "PRX-T33 Intimate Zone (Bikini)", duration: "", price: "$280" },
      { name: "PRX-T33 Underarms", duration: "", price: "$250" }
    ]
  },
  {
    title: "Glow Peel",
    subtitle: "Signature glow ritual — pre-event radiance.",
    items: [
      { name: "Glow Peel — Face", duration: "", price: "$190" },
      { name: "Glow Peel — Neck", duration: "", price: "$240" }
    ]
  },
  {
    title: "Hydrafacial",
    subtitle: "Signature medical facials for immediate radiance.",
    items: [
      { name: "Hydrafacial Deluxe", duration: "1 hour 20 minutes", price: "$280" },
      { name: "Hydrafacial Platinum", duration: "1 hour 30 minutes", price: "$300" },
      { name: "Hydrafacial Signature", duration: "2 hours", price: "$280–$350" },
      { name: "Hydrafacial Back", duration: "", price: "$320" },
      { name: "Back Hydrafacial Deep Clean", duration: "", price: "$350" }
    ]
  },
  {
    title: "IPL Lumecca Add-ons",
    subtitle: "Targeted photofacials for hands and legs.",
    items: [
      { name: "IPL Lumecca Hands", duration: "", price: "$350" },
      { name: "IPL Lumecca Legs", duration: "", price: "$450" }
    ]
  },
  {
    title: "Deep Cleansing",
    subtitle: "Purifying rituals for congested and reactive skin.",
    items: [
      { name: "Deep Cleansing Russian Facial — Holly Land + Peel", duration: "2 hours", price: "$250" },
      { name: "Deep Clean Facial", duration: "", price: "$320" },
      { name: "Carboxy Therapy", duration: "30 minutes", price: "$150" },
      { name: "Micro-current", duration: "", price: "$200" }
    ]
  },
  {
    title: "Additional",
    subtitle: "Complementary treatments personalised to your plan.",
    items: [
      { name: "Vitamin Monaco", duration: "1 hour 20 minutes", price: "$550" }
    ]
  }
];

export const detailSlugFor = (name) => HAS_DETAIL[name] || null;
